export default __webpack_public_path__ + "static/media/gold.cfee2fc8.png";